import { ConnectionLevel } from "../../utils/connectionQuality";

/** Translation keys of the indicator. */
export const CONNECTION_TEXT_KEY = "mainLayout.header.connectionQuality";

const LEVELS_WITH_HINT = new Set<ConnectionLevel>([
	"offline",
	"noServer",
	"poor",
	"unstable",
]);

/** Levels that come with an advice line (`hint.<level>`). */
export const hasConnectionHint = (level: ConnectionLevel): boolean =>
	LEVELS_WITH_HINT.has(level);

/** No way to reach the server right now: offline or no answer. */
export const isNoLink = (level: ConnectionLevel): boolean =>
	level === "offline" || level === "noServer";
